import { render, staticRenderFns } from "./InsuranceCompanyChangeActivationType.vue?vue&type=template&id=0da735af&"
import script from "./InsuranceCompanyChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./InsuranceCompanyChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports